export enum LOCAL_STORAGE_KEYS {
  TOKEN = 't',
  TOKEN_EXPIRATION_DATE = 'exp_at',
  COUNTRY_CODES = 'country_codes',
  CLICK_TO_CALL_PHONE_NUMBER = 'click_to_call_phone_number',
}
